import $ from 'jquery' // jQuery
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('page-top')) {
  pageTop()
}

function pageTop() {
  const spritBg = document.getElementById('js-sprit-bg')
  spritBg.addEventListener('transitionend', function (e) {
    $('.topSpritItem').addClass('active')
  })
  let mvSibuki = document.getElementById('js-mv-sibuki')
  const mvPeople = document.getElementById('js-mv-people')
  const mvSplash = document.getElementById('js-mv-splash')
  const mvBrush = document.getElementById('js-mv-brush')
  mvSibuki.addEventListener('transitionend', function (e) {
    $('#js-mv-people').addClass('active')
  })
  mvPeople.addEventListener('animationstart', function (e) {
    $('.js-mv-splash').addClass('active')
  })
  mvSplash.addEventListener('transitionend', function (e) {
    $('.js-mv-brush').addClass('active')
  })
  mvBrush.addEventListener('animationend', function (e) {
    $('.js-mv-title').addClass('active')
  })

  if (document.getElementsByClassName('js_topSlider')[0]) {
    const topSwiper = new Swiper('.js_topSlider', {
      slidesPerView: 1.2,
      loop: true,
      speed: 6000,
      spaceBetween: 10,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      breakpoints: {
        // >= 769

        769: {
          spaceBetween: 20,
          slidesPerView: 3.2,
        },
      },
    })
  }
}

//==================================================================================================
//
//  ##   ##  ##  ####    #####   #####         #####   ##        ###    ##    ##  #####  #####
//  ##   ##  ##  ##  ##  ##     ##   ##        ##  ##  ##       ## ##    ##  ##   ##     ##  ##
//  ##   ##  ##  ##  ##  #####  ##   ##        #####   ##      ##   ##    ####    #####  #####
//   ## ##   ##  ##  ##  ##     ##   ##        ##      ##      #######     ##     ##     ##  ##
//    ###    ##  ####    #####   #####         ##      ######  ##   ##     ##     #####  ##   ##
//
//==================================================================================================

if (document.getElementById('video')) {
  // Video Player
  const video = document.getElementById('video')
  const playButton = document.getElementById('playpause')

  function togglePlay() {
    if (video.paused || video.ended) {
      video.play()
    } else {
      video.pause()
    }
  }

  playButton.addEventListener('click', togglePlay)
  video.addEventListener('playing', function () {
    playButton.style.opacity = 0
  })
  video.addEventListener('pause', function () {
    playButton.style.opacity = 1
  })
}
